import { render } from "./Loading.vue?vue&type=template&id=e5ff4e82"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=e5ff4e82&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__